module.exports = __webpack_public_path__ + "img/register.9c122c68.svg";